module.exports = __webpack_public_path__ + "img/patio-art.a9cb1deb.jpg";